import React, { useState } from 'react';
import styles from './index.module.css';

export const OTPInput = () => {
  const [first, setfirst] = useState('');
  return (
    <div>
      {[1, 2, 3, 4, 5].map((digit, idx) => (
        <input
          key={idx}
          type="text"
          inputMode="numeric"
          pattern="/^[0-9\b]+$/"
          maxLength={5}
          className={styles.otpinput}
        />
      ))}
    </div>
  );
};
